export const common = {
  // Navigation
  'nav.features': 'Funktioner',
  'nav.howItWorks': 'Hur det fungerar',
  'nav.pricing': 'Priser',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Om oss',
  'nav.getStarted': 'Kom igång',

  // About Us Section
  'aboutUs.badge': 'Om oss',
  'aboutUs.title': 'Om oss',
  'aboutUs.line1': 'Idéer är billiga.',
  'aboutUs.line2': 'Kapital inte. Tid ännu mindre.',
  'aboutUs.paragraph1': 'IdeaOracle.ai grundades eftersom de flesta affärsidéer inte misslyckas på grund av brist på mod – utan på grund av brist på ärlighet. För mycket bekräftelse. För lite verklighet.',
  'aboutUs.belief1a': 'Vi tror inte på hype.',
  'aboutUs.belief1b': 'Vi tror på marknadslogik.',
  'aboutUs.belief2a': 'Vi tror inte på motivation.',
  'aboutUs.belief2b': 'Vi tror på efterfrågan, konkurrens och differentiering.',
  'aboutUs.mission1': 'Vår uppgift är inte att få idéer att se bra ut.',
  'aboutUs.mission2': 'Vår uppgift är att avslöja deras bärkraft.',
  'aboutUs.analysis': 'IdeaOracle.ai analyserar affärsnischer för strukturell marknadsmekanik, realistisk efterfrågan, konkurrensintensitet och genomförbarhet. Inte emotionellt. Inte optimistiskt. Utan nyktert.',
  'aboutUs.failure1': 'De flesta idéer misslyckas.',
  'aboutUs.failure2': 'Inte för att grundare är oförmögna –',
  'aboutUs.failure3': 'utan för att ingen var tillräckligt tydlig i förväg.',
  'aboutUs.clarity': 'Vi existerar för att leverera den tydligheten.',
  'aboutUs.value1': 'Obekvämt.',
  'aboutUs.value2': 'Direkt.',
  'aboutUs.value3': 'Konsekvent.',
  'aboutUs.confirm': 'Om en idé har substans, bekräftar vi det.',
  'aboutUs.deny': 'Om inte, säger vi det också.',
  'aboutUs.noApplause': 'Utan applåder.',
  'aboutUs.noSugarcoating': 'Utan försköning.',
  'aboutUs.noTheater': 'Utan teater.',

  // Hero Section
  'hero.badge': 'Besluts-AI för affärsnischer',
  'hero.title1': 'Idéer är billiga.',
  'hero.title2': 'Dåliga beslut är det inte.',
  'hero.subtitle': 'En AI som utvärderar din affärsnisch',
  'hero.subtitleLine2': 'innan du investerar.',
  'hero.cta': 'Kontrollera idé',
  'hero.ctaSecondary': 'Hur det fungerar',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Krediter per förfrågan',
  'hero.stat2Value': 'Från 7',
  'hero.stat2Label': 'Betygsnivåer',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Ärlig och privat',

  // Features Section
  'features.title1': 'Kraftfulla funktioner för',
  'features.title2': 'moderna',
  'features.title3': 'företag',
  'features.honestVerdict.title': 'Ärligt omdöme, inte en hype-poäng',
  'features.honestVerdict.description': 'Tydliga bra/medel/svag-omdömen baserade på riktiga marknadsdata och konkurrentanalys. Inga 9/10-betyg gjorda för att smickra varje idé.',
  'features.fullJourney.title': 'Från idé-test till Builder Report',
  'features.fullJourney.description': 'Validera i chatten, gräv djupare i marknadsanalysen, exportera en 25–75-sidors Builder Report med personas, ekonomi, go-to-market och pitch deck.',
  'features.multilingual.title': '21 språk, lokala marknadsdata',
  'features.multilingual.description': 'Från ett schweiziskt SMF till en solo-grundare i São Paulo — AI:n svarar på ditt språk, med källor från din marknad.',

  // How It Works
  'howItWorks.title': 'Hur det fungerar',
  'howItWorks.subtitle': 'Fyra steg till klarhet om din affärsnisch.',
  'howItWorks.step1Title': 'Välj en plan',
  'howItWorks.step1Desc': 'Starter, Pro eller Builder – beroende på djupet i din granskning.',
  'howItWorks.step2Title': 'Fråga AI:n',
  'howItWorks.step2Desc': 'Ställ dina frågor om nischen. Varje förfrågan kostar 30 krediter.',
  'howItWorks.step3Title': 'Få ärlig dom',
  'howItWorks.step3Desc': 'AI:n bedömer: Bra, Medel eller Dålig. Utan omsvep.',
  'howItWorks.step4Title': 'Fatta ett beslut',
  'howItWorks.step4Desc': 'Nu vet du om det är värt att gå vidare.',

  // Pricing
  'pricing.title': 'Priser',
  'pricing.subtitle': 'Välj planen som passar djupet i din granskning.',
  'pricing.yearlyDiscount': 'Årsprenumeration:',
  'pricing.yearlyDiscountValue': '-20% rabatt',
  'pricing.perMonth': 'per månad',
  'pricing.selectPlan': 'Välj plan',
  'pricing.mostPopular': 'Mest populär',
  'pricing.footer': 'Alla priser i CHF. Krediter dras endast av för framgångsrika AI-svar.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'För initiala verklighetstest.',
  'pricing.starter.credits': '2 500 krediter',
  'pricing.starter.feature1': 'Generera nischidé',
  'pricing.starter.feature2': 'Förfina nisch',
  'pricing.starter.feature3': 'Marknadsverklighetscheck',
  'pricing.starter.feature4': 'Konkurrensbedömning',
  'pricing.starter.feature5': 'Timingbedömning',
  'pricing.starter.feature6': 'Ärlig dom',
  'pricing.starter.feature7': 'Privata sessioner',
  'pricing.starter.feature8': 'Historik och export',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'För djupare granskning.',
  'pricing.pro.credits': '5 000 krediter',
  'pricing.pro.feature1': 'Alla Starter-funktioner',
  'pricing.pro.feature2': 'Fler krediter för intensiv granskning',
  'pricing.pro.feature3': 'Förbättringsförslag',
  'pricing.pro.feature4': 'Alternativa nischer',
  'pricing.pro.feature5': 'Detaljerad marknadsanalys',
  'pricing.pro.feature6': 'Prioriterad support',
  'pricing.pro.feature7': 'Avancerade filter',
  'pricing.pro.feature8': 'Sessionsfavoriter',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Idé → Utvecklarbriefing.',
  'pricing.builder.credits': 'Obegränsade krediter',
  'pricing.builder.feature1': 'Alla Pro-funktioner',
  'pricing.builder.feature2': 'Obegränsade AI-förfrågningar',
  'pricing.builder.feature3': 'Builder-läge: Utvecklarbriefing',
  'pricing.builder.feature4': 'Strukturerad projektöversikt',
  'pricing.builder.feature5': 'Användarflöden och kärnfunktioner',
  'pricing.builder.feature6': 'Tekniska anteckningar',
  'pricing.builder.feature7': 'Definiera icke-mål',
  'pricing.builder.feature8': 'Fair use-hastighetsgräns',
  'pricing.builder.limitNote': 'Fair use-gräns',
  'pricing.monthlyReset': 'Månatlig återställning',

  // Modal
  'pricing.modal.selected': 'vald',
  'pricing.modal.comingSoon': 'Registrering och betalningshantering kommer snart att vara tillgänglig.',
  'pricing.modal.patience': 'Vi arbetar för att ge dig en säker och sömlös upplevelse. Var tålmodig.',
  'pricing.modal.understood': 'Förstått',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Besvarat ärligt och kritiskt.',
  'faq.q1': 'Vad gör IdeaOracle.ai konkret?',
  'faq.a1': 'IdeaOracle.ai utvärderar affärsidéer och nischer för marknadslogik, verklig efterfrågan, konkurrens, differentiering och genomförbarhet.\nOm substans finns, visar vi hur den kan skärpas strategiskt.\nOm inte, säger vi det.',
  'faq.q2': 'Genererar ni också idéer?',
  'faq.a2': 'Ja.\nMen inte blint.\nVi utvecklar tillvägagångssätt baserade på marknadslogik – inte motivation eller trendhype.',
  'faq.q3': 'Optimerar ni affärsmodeller?',
  'faq.a3': 'Ja – om potential finns.\nVi polerar inte illusioner.\nVi gör bärkraftiga koncept mer motståndskraftiga.',
  'faq.q4': 'Vad skiljer er från andra AI-verktyg?',
  'faq.a4': 'Andra verktyg levererar inspiration.\nVi levererar bedömning.\nFokus ligger på realism, inte entusiasm.',
  'faq.q5': 'Är detta en garanti för framgång?',
  'faq.a5': 'Nej.\nVi minskar felbeslut – vi eliminerar inte risk.',
  'faq.q6': 'Vem är IdeaOracle.ai för?',
  'faq.a6': 'Grundare före lansering\nEntreprenörer före expansion\nSide-builders före tidsinvestering\nInvesterare före granskning\n\nKort sagt: För människor som vill ha klarhet före kapital.',
  'faq.q7': 'Vad om jag bara söker bekräftelse?',
  'faq.a7': 'Då är IdeaOracle.ai inte rätt verktyg.',
  'faq.q8': 'Hur ärlig är analysen?',
  'faq.a8': 'Så ärlig som data och marknadsmekanik tillåter.\nIngen eufori. Ingen skonsamhet.',
  'faq.q9': 'Ersätter ni marknadsundersökningar?',
  'faq.a9': 'Nej.\nVi är en strategisk förhandsbedömning – inte en fullständig marknadsstudie.',
  'faq.q10': 'Varför så kompromisslösa?',
  'faq.a10': 'Eftersom misslyckande är dyrt.\nÄrlighet inte.',

  // Footer
  'footer.description': 'Denna plattform hjälper dig inte att må bra – utan att fatta rätt beslut.',
  'footer.product': 'Produkt',
  'footer.aiAssistant': 'AI-assistent',
  'footer.howItWorks': 'Hur det fungerar',
  'footer.pricing': 'Priser',
  'footer.faq': 'FAQ',
  'footer.legal': 'Juridiskt',
  'footer.privacy': 'Integritet',
  'footer.terms': 'Villkor',
  'footer.imprint': 'Impressum',
  'footer.support': 'Support',
  'footer.contact': 'Kontakt',
  'footer.documentation': 'Dokumentation',
  'footer.copyright': '© 2025 IdeaOracle.ai. Alla rättigheter förbehållna.',

  // AI Assistant
  'aiAssistant.title': 'AI-nischassistent',
  'aiAssistant.subtitle': 'Frågor om nischer',
  'aiAssistant.welcomeMessage': 'Hej! Beskriv din idé eller fråga mig om en nisch. Jag ger dig en tydlig och ärlig bedömning.',
  'aiAssistant.demoResponse': 'Detta är en demo. För att få riktiga AI-bedömningar, registrera dig och välj en plan.',
  'aiAssistant.placeholder': 'Beskriv din idé...',

  // Header & Sidebar
  'dashboard.header.title': 'Instrumentpanel',
  'dashboard.sidebar.overview': 'Översikt',
  'dashboard.sidebar.newAnalysis': 'AI-assistent',
  'dashboard.sidebar.history': 'Historik',
  'dashboard.sidebar.credits': 'Krediter',
  'dashboard.sidebar.settings': 'Inställningar',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Välkommen tillbaka, {{name}}',
  'dashboard.overview.subtitle': 'Här är en snabb översikt över din aktivitet',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Återstående krediter',
  'dashboard.stats.totalAnalyses': 'Totala analyser',
  'dashboard.stats.goodRatings': 'Positiva betyg',
  'dashboard.stats.nextReset': 'Nästa återställning om',
  'dashboard.stats.days': 'dagar',

  // Quick Actions
  'dashboard.quickActions.title': 'Snabbåtgärder',
  'dashboard.quickActions.checkNewIdea': 'Kontrollera en idé',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analysera en befintlig affärsidé',
  'dashboard.quickActions.generateIdea': 'Generera en idé',
  'dashboard.quickActions.generateIdeaDesc': 'Hitta en ny lönsam nisch',
  'dashboard.quickActions.builderBriefing': 'Builder-briefing',
  'dashboard.quickActions.builderBriefingDesc': 'Förvandla en idé till en utvecklarklar briefing',
  'dashboard.quickActions.premiumOnly': 'Endast Builder',

  // Chat Header
  'chat.title': 'AI-nischassistent',
  'chat.subtitle': 'Ställ frågor om nischer. Jag bedömer kritiskt och ärligt.',
  'chat.creditsLabel': 'Krediter',

  // Chat Welcome
  'chat.welcomeTitle': 'Välkommen till AI-nischassistenten',
  'chat.welcomeDesc': 'Beskriv din idé eller fråga om en nisch. Jag bedömer ärligt: Bra, Medel eller Dålig.',
  'chat.aiWelcome': 'Hej! Beskriv din idé eller fråga mig om en nisch. Jag ger dig en tydlig och ärlig bedömning.',

  // Chat Suggestions
  'chat.suggestion1': 'Hitta en lönsam nisch åt mig.',
  'chat.suggestion2': 'Jag har en idé – bedöm den ärligt.',
  'chat.suggestion3': 'Vilka nischer har potential just nu?',
  'chat.suggestion4': 'Förfina denna nisch och gör den mer specifik.',

  // Chat Actions
  'chat.newConversation': 'Ny konversation',
  'chat.today': 'Idag',
  'chat.yesterday': 'Igår',
  'chat.thisWeek': 'Denna vecka',
  'chat.thisMonth': 'Denna månad',
  'chat.older': 'Äldre',
  'chat.messages': 'meddelanden',
  'chat.renameConversation': 'Byt namn',
  'chat.deleteConversation': 'Ta bort',
  'chat.cancel': 'Avbryt',
  'chat.rename': 'Byt namn',
  'chat.delete': 'Ta bort',
  'chat.favorite': 'Lägg till favorit',
  'chat.unfavorite': 'Ta bort favorit',
  'chat.searchSessions': 'Sök konversationer...',
  'chat.noResults': 'Inga resultat hittades',
  'chat.noSessions': 'Inga konversationer ännu',
  'chat.enterNewName': 'Ange nytt namn...',
  'chat.deleteConfirmMessage': 'Är du säker på att du vill ta bort denna konversation? Denna åtgärd kan inte ångras.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Skriv din fråga… (kostar 30 krediter)',
  'chat.send': 'Skicka',
  'chat.voice': 'Tala',
  'chat.listeningPlaceholder': 'Jag lyssnar... Tala nu.',
  'chat.stopListening': 'Stoppa inspelning',
  'chat.recording': 'Spelar in...',
  'chat.speechNotSupported': 'Taligenkänning stöds inte av din webbläsare.',
  'chat.microphonePermissionDenied': 'Mikrofonåtkomst nekades. Tillåt åtkomst i dina webbläsarinställningar.',
  'chat.errorNotEnoughCredits': 'Inte tillräckligt med krediter. Uppgradera din plan eller vänta på nästa återställning.',
  'chat.errorAiFailed': 'AI-svar misslyckades. Inga krediter drogs av.',
  'chat.errorRateLimit': 'För många förfrågningar. Vänta ett ögonblick.',

  // Ratings
  'rating.good': 'Bra',
  'rating.medium': 'Medel',
  'rating.bad': 'Dålig',

  // Auth Page
  'auth.branding.headline1': 'Inte varje idé är bra.',
  'auth.branding.headline2': 'Vi berättar ärligt vilken.',
  'auth.branding.subtitle': 'En besluts-AI för affärsnischer. Tydlig. Kritisk. Utan omsvep.',
  'auth.benefits.privacy.title': '100% Privat',
  'auth.benefits.privacy.desc': 'Dina idéer förblir helt privata och säkra.',
  'auth.benefits.honest.title': 'Ärlig AI',
  'auth.benefits.honest.desc': 'Utan omsvep – bara tydlig, kritisk feedback.',
  'auth.benefits.fast.title': 'Snabba Resultat',
  'auth.benefits.fast.desc': 'Få klarhet om din nisch på några minuter.',
  'auth.trust.users': 'Aktiva Användare',
  'auth.trust.ideas': 'Analyserade Idéer',
  'auth.trust.rating': 'Betyg',
  'auth.login.title': 'Logga in',
  'auth.login.headline': 'Välkommen tillbaka',
  'auth.login.subtitle': 'Logga in för att fortsätta din resa.',
  'auth.login.forgotPassword': 'Glömt lösenord?',
  'auth.login.submit': 'Logga in',
  'auth.login.noAccount': 'Inget konto ännu?',
  'auth.login.signUp': 'Registrera dig',
  'auth.register.title': 'Registrera',
  'auth.register.headline': 'Skapa ditt konto',
  'auth.register.subtitle': 'Börja analysera dina affärsidéer idag.',
  'auth.register.submit': 'Skapa Konto',
  'auth.register.hasAccount': 'Har du redan ett konto?',
  'auth.register.signIn': 'Logga in',
  'auth.fields.name': 'Fullständigt Namn',
  'auth.fields.email': 'E-postadress',
  'auth.fields.password': 'Lösenord',
  'auth.fields.confirmPassword': 'Bekräfta Lösenord',
  'auth.fields.selectPlan': 'Välj din plan',
  'auth.placeholders.name': 'Ange ditt namn',
  'auth.placeholders.email': 'Ange din e-post',
  'auth.placeholders.password': 'Ange ditt lösenord',
  'auth.placeholders.confirmPassword': 'Bekräfta ditt lösenord',
  'auth.terms.accept': 'Jag accepterar',
  'auth.terms.terms': 'Villkoren',
  'auth.privacy.accept': 'Jag accepterar',
  'auth.privacy.policy': 'Integritetspolicyn',
  'auth.errors.nameRequired': 'Namn krävs',
  'auth.errors.emailRequired': 'E-post krävs',
  'auth.errors.emailInvalid': 'Ange en giltig e-post',
  'auth.errors.passwordRequired': 'Lösenord krävs',
  'auth.errors.passwordLength': 'Lösenordet måste vara minst 8 tecken',
  'auth.errors.passwordMismatch': 'Lösenorden matchar inte',
  'auth.loading': 'Vänta...',
  'auth.or': 'eller fortsätt med',
  'auth.social.google': 'Fortsätt med Google',
  'auth.social.apple': 'Fortsätt med Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3 dagars gratis åtkomst',
  'pricing.trial.credits': '250 krediter',
  'pricing.trial.free': 'Gratis',
  'pricing.trial.duration': 'Ingen kostnad i 3 dagar',
  'pricing.trial.cta': 'Starta gratis provperiod',
  'pricing.trial.feature1': '250 krediter för att utforska AI:n',
  'pricing.trial.feature2': 'Full åtkomst i 3 dagar',
  'pricing.trial.feature3': 'Inget kreditkort krävs',
  'pricing.trial.feature4': 'Avsluta när som helst',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10 000 krediter + 25-sidors Builder-rapport',
  'pricing.gold.credits': '10 000 krediter',
  'pricing.gold.feature1': '10 000 krediter',
  'pricing.gold.feature2': '25-sidors Builder-rapport',
  'pricing.gold.feature3': 'Alla Starter- och Pro-funktioner',
  'pricing.gold.feature4': 'Marknadsanalys och sammanfattning',
  'pricing.gold.feature5': 'Möjligheter, risker, rekommendationer',
  'pricing.gold.feature6': 'Ladda ner PDF',
  'pricing.gold.feature7': 'Support',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15 000 krediter + 100-sidors Builder-rapport',
  'pricing.platinum.credits': '15 000 krediter',
  'pricing.platinum.feature1': '15 000 krediter',
  'pricing.platinum.feature2': '100-sidors Builder-rapport',
  'pricing.platinum.feature3': 'Alla Gold-funktioner',
  'pricing.platinum.feature4': 'Builder-läge: utvecklarbriefingar',
  'pricing.platinum.feature5': 'Strukturerad sammanfattning',
  'pricing.platinum.feature6': 'Avancerad marknadsanalys',
  'pricing.platinum.feature7': 'Support',

  // Pricing UI
  'pricing.monthly': 'Månadsvis',
  'pricing.yearly': 'Årsvis',
  'pricing.savings': 'besparing',
  'pricing.billedYearly': 'Faktureras årsvis',

  // Hero trial CTA
  'hero.trialTitle': 'Starta din gratis provperiod',
  'hero.creditsLabel': 'Krediter',
  'hero.trialTagline': 'Prova vår AI-assistent gratis i 3 dagar',
  'hero.trialCta': 'Registrera dig & få 250 krediter',
  'hero.trialNoCard': 'Inget kreditkort krävs. Ingen bindning.',

  // Admin
  'admin.dashboard.tabs.plans': 'Abonnemang',

  // Credit top-up
  'dashboard.credits.topup.button': 'Fyll på krediter',
  'dashboard.credits.topup.buttonTitle': 'Köp fler krediter utan att byta plan',
  'dashboard.credits.topup.title': 'Fyll på krediter',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 per kredit — ingen planändring krävs',
  'dashboard.credits.topup.quickAmounts': 'Snabbval',
  'dashboard.credits.topup.custom': 'Anpassad',
  'dashboard.credits.topup.totalLabel': 'Totalt',
  'dashboard.credits.topup.creditsLabel': 'Krediter',
  'dashboard.credits.topup.confirm': 'Köp nu',
  'footer.disclaimer': 'Ansvarsfriskrivning',
  'legal.backToHome': 'Tillbaka till startsidan',
  'legal.lastUpdated': 'Senast uppdaterad',
  'legal.allRightsReserved': 'Alla rättigheter förbehållna.',
  'legal.authoritativeNotice': 'En lokaliserad version på ditt språk är ännu inte tillgänglig. Den engelska, juridiskt bindande texten visas nedan.',
  'legal.translationNotice': 'Detta är en bekvämlighetsöversättning. Den engelska versionen är det juridiskt bindande originalet.',
};

export default common;
